var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground,"short-title":"Relevando","title":"Relevando Peligros"}},[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: 'Dashboard',
          icon: 'ni ni-tv-2 text-primary',
          path: '/dashboard',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Peligros',
          icon: 'fa fa-exclamation-triangle text-orange',
          path: '/peligros',
        }}}),(['administrador'].includes(_vm.role))?_c('sidebar-item',{attrs:{"link":{
          name: 'Responsables',
          icon: 'ni ni-building text-medium',
          path: '/responsables',
        }}}):_vm._e(),(['administrador'].includes(_vm.role))?_c('sidebar-item',{attrs:{"link":{
          name: 'Sedes',
          icon: 'ni ni-shop text-info',
          path: '/sedes',
        }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
          name: 'Mapa',
          icon: 'ni ni-pin-3 text-orange',
          path: '/maps',
        }}}),(['administrador'].includes(_vm.role))?_c('sidebar-item',{attrs:{"link":{
          name: 'Noticias',
          icon: 'fa fa-newspaper',
          path: '/posts',
        }}}):_vm._e(),(['administrador'].includes(_vm.role))?_c('sidebar-item',{attrs:{"link":{
          name: 'Estadísticas',
          icon: 'ni ni-chart-pie-35 text-success',
          path: '/estadisticas',
        }}}):_vm._e(),(['administrador'].includes(_vm.role))?_c('sidebar-item',{attrs:{"link":{
          name: 'Categorías',
          icon: 'ni ni-bullet-list-67 text-medium',
          path: '/categorias',
        }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
          name: 'Contacto',
          icon: 'fa fa-envelope',
          path: '/contacts',
        }}}),(['administrador'].includes(_vm.role))?_c('sidebar-item',[_vm._v("Administración")]):_vm._e(),(['administrador'].includes(_vm.role))?_c('sidebar-item',{attrs:{"link":{
          name: 'Staff',
          icon: 'ni ni-circle-08 text-medium',
          path: '/staff',
        }}}):_vm._e(),(['administrador'].includes(_vm.role))?_c('sidebar-item',{attrs:{"link":{
          name: 'Usuarios',
          icon: 'ni ni-circle-08 text-medium',
          path: '/usuarios',
        }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
          name: 'Relevamientos',
          icon: 'ni ni-single-02 text-info',
          path: '/formalities',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Perfil',
          icon: 'ni ni-single-02 text-orange',
          path: '/perfil',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Notificaciones',
          icon: 'ni ni-bell-55 text-orange',
          path: '/notificaciones',
        }}}),_c('hr',{staticClass:"my-3",staticStyle:{"border":"0","border-top":"1px solid rgba(0, 0, 0, 0.1)","min-width":"80%","overflow":"visible","box-sizing":"content-box","height":"0"}})],1)],2),_c('div',{staticClass:"main-content",attrs:{"data":_vm.sidebarBackground}},[_c('dashboard-navbar'),_c('div',{on:{"click":_vm.toggleSidebar}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }